import { gql } from '@apollo/client';
import performQuery from 'features/help/queries/contentfulClient';
import { HELP_SITE_SETTINGS_ID } from '../constants';
import { SiteSettings } from '../types/siteSettings';

export type GetTopicCollectionArgs = {
  iconWidth: number;
  iconHeight: number;
};

const SITE_SETTINGS_QUERY = gql`
  query siteSettings {
    ansHelpSiteSettings(id: "${HELP_SITE_SETTINGS_ID}") {
      paginationLimit
    }
  }
`;

export default async function useSiteSettingsQuery() {
  const response = await performQuery(SITE_SETTINGS_QUERY, {});

  if (response.hasError) {
    return {
      data: null,
      error: true,
    };
  }

  return {
    data: response.res?.data?.ansHelpSiteSettings as SiteSettings | null,
    error: false,
  };
}
